import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RenderizarFoto from './RenderizarFoto';
import { Row, Col, Form } from 'react-bootstrap';
import Markdown from './Markdown';
import { useProvider, Toast, isNative } from '../../context/MenuProvider';


const RenderizarProduto = ({
  key,
  bcolor,
  bgimg,
  to,
  onClick,
  onClick2,
  onClick3,
  lm,
  col,
  col2,
  icon,
  icon2,
  src,
  className,
  classNameTitulo,
  alt,
  text1,
  text2,
  text3,
  text4,
  titulo,
  titulo2,
  titulo3,
  formItem,
  setFormItem,
  label,
  extra,
  markdown,
}) => {
  const navigate = useNavigate();
  const [duplo, setDuplo] = useState(false);
  const [item, setItem] = useState(formItem);
  const {
    site,
  } = useProvider();
  
  const [finalSrc, setFinalSrc] = useState(src);
  const [finalBg, setFinalBg] = useState(bgimg);
  
  // useEffect(() => {
  //   if (!isNative) return;
  //   const domain = site?.domain || "";
  
  //   if (src && src.startsWith('/')) {
  //     setFinalSrc(`https://${domain}${src}`);
  //   }
    
  //   if (bgimg && bgimg.startsWith('/')) {
  //     setFinalBg(`https://${domain}${bgimg}`);
  //   }
  // }, [src, isNative, bgimg, site?.domain]);


  const backgroundStyle = finalBg ? {
    //backgroundImage: `url("https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(endereco)}&zoom=17&markers=color:red%7C${encodeURIComponent(endereco)}&size=800x700&maptype=roadmap&format=jpg&key=${apiKey}")`,
    backgroundImage: `url("${finalBg}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    //marginTop:'-100px',
    //paddingTop:'150px'
    minHeight:'80px'
  }:{};

  const handleClick = (event) => {
    event.preventDefault();
    if (onClick) onClick();
    if (to) navigate(to);
  };
  

  const handleClick2 = (event) => {
    event.preventDefault();
    if (onClick2) onClick2();
  };

  const handleClick3 = (event) => {
    event.preventDefault();
    if (onClick3) onClick3();
  };
  
  useEffect(()=>{
    if(setFormItem) setFormItem(item);
  },[item])

  const conteudoInterno = () => (
    <div>
      {(icon2 || text1) && (
        <>
          <p className={`mb-0 ${icon2 || text1?'':'d-none'}`}>
            {Array.isArray(icon2) ? (
              icon2.map((icon, index) => (
                <span>
                    <i key={index} className={`pe-1 bi ${icon}`}></i>
                </span>
              ))
            ) : (<>
              {icon2 && (<span>
                  <i className={`pe-1 bi ${icon2}`}></i>
              </span>)}
            </>)}
            {text1 && (<span className="text-muted">{text1}</span>)}
          </p>
        </>
      )}
      <div className="d-flex w-100 justify-content-between">
        <h5 className={`mb-1 ${classNameTitulo}`}>
          {titulo} <i className="text-muted text-small">{titulo2}</i>
        </h5>
      </div>
      <small className="text-muted">
        {text2}
        {setFormItem && (
          <>
            <Form.Group controlId="formPreco">
              <div className="text-muted small">Preço Unitário</div>
              <div className="input-group">
                <span className="input-group-text">{label || ''}</span>
                <Form.Control 
                    type="number" 
                    value={item?.valor} 
                    onChange={(e) => 
                      setItem((prevItem) => ({
                        ...prevItem,
                        valor: e.target.value
                      }))
                    }
                    onBlur={(e) => 
                      setItem((prevItem) => ({
                        ...prevItem,
                        valor: parseFloat(e.target.value||0).toFixed(2)
                      }))
                    }
                />
              </div>
            </Form.Group>
          </>
        )}
        <div>{text4}</div>
        {markdown && (<Markdown texto={markdown} />)}
      </small>
    </div>
  );

  const conteudoGeral = () => (
    <div className="row align-items-center">
      {duplo && (titulo3 || text3) && (
        <Link onClick={handleClick2} className="col-auto fs-2 text-center text-danger">
          <i className="bi bi-dash-circle"></i>
        </Link>
      )}
      <div style={backgroundStyle} className={`${col || 'col-2'} ${duplo ? 'position-relative' : 'text-center'}`}>
        {!icon ? (
          <>
            {(finalSrc) && <RenderizarFoto src={finalSrc} className={className} alt={alt} />}
            {(!finalBg && !finalSrc) && <RenderizarFoto src={finalSrc} className={className} alt={alt} />}
          </>
        ) : (
          <span className={` ${icon}`} style={{ fontSize: '3em' }}></span>
        )}
        {duplo && (titulo3 || text3) && (
          <span className="position-absolute bottom-0 end-0 bg-white rounded-circle p-1">
            <b>{titulo3 || text3}</b>
          </span>
        )}
      </div>
      {duplo ? (
        <Link className="col text-decoration-none">
          <Row className="align-items-center">
            <Col>
              {conteudoInterno()}
            </Col>
            <Col xs="auto" onClick={handleClick3} className="text-success fs-2"><i className="bi bi-plus-circle"></i></Col>
          </Row>
        </Link>
      ) : (
        <>
          <div className="col">{conteudoInterno()}</div>
          <div className={`${col2 || 'd-none'}`}>
            <div className="d-flex w-100 justify-content-between">
              <h6 className={`mb-1 ${classNameTitulo}`}>{titulo3}</h6>
            </div>
            <small className="text-muted">{text3}</small>
          </div>
        </>
      )}
      {extra && (
        <div className="col-12">{extra}</div>
      )}
    </div>
  );

  useEffect(() => {
    setDuplo(!!onClick2 || !!onClick3);
  }, [onClick2, onClick3]);

  return (
    <div>
      {duplo ? (
        <div
          key={key}
          className={`list-group-item list-group-item-action ${lm}`}
          style={{ borderLeft: bcolor ? `5px solid ${bcolor}` : '' }}
        >
          {conteudoGeral()}
        </div>
      ) : (
        <Link
          key={key}
          className={`list-group-item list-group-item-action ${lm}`}
          to={to}
          onClick={handleClick}
          style={{ borderLeft: bcolor ? `5px solid ${bcolor}` : '' }}
        >
          {conteudoGeral()}
        </Link>
      )}
    </div>
  );
};

export default RenderizarProduto;